import { useQuery } from "@tanstack/react-query";
import { Template } from "PFApp/booking/types/manage_reports";
import { fetchTemplates } from "PFCore/services/manage_reports";
import { Collection } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { queryKeys } from "./query_keys";

export const useTemplates = (options?: QueryOptions<Collection<Template[]>>) =>
  useQuery<Collection<Template[]>>(queryKeys.templates, async () => await fetchTemplates(), options);
